import {validators} from 'vue-form-generator';
import {invalidVatId} from './customValidations';
import {setCustomValidationProperties} from '../customValidationHelpers';

const countriesWithVAT = ['united kingdom', 'france', 'belgium', 'germany', 'luxembourg', 'liechtenstein', 'austria', 'netherlands', 'switzerland', 'ireland', 'spain', 'italy', 'portugal'];

export const vatId = {
    type: 'input',
    inputType: 'text',
    label: '',
    id: 'vat-id',
    model: 'vatId',
    required: false,
    visible: function(model) {
        let country = model.country.toLowerCase() || "";
        return country && countriesWithVAT.includes(country);
    },
    disabled: false,
    styleClasses: "col xs-12 md-3",
    min: 8,
    validator: [
        validators.string,
        setCustomValidationProperties(invalidVatId, "invalidVatId")
    ],
}
